<template>
	<div>
		<modal ref="modalNovoUsuario">
			<div class="row">
				<div class="col-md-12">
					<button type="button" class="close" @click="$refs.modalNovoUsuario.modalHide()">
						<span aria-hidden="true">&times;</span>
					</button>

					<p class="modal-title">
						{{ _traducao('global', 'novoUsuario').toUpperCase() }}
					</p>
					<hr style="margin-top: 6px" />
				</div>
			</div>

			<flCadastroDeUsuario
				@atualiza-lista="usuarioSalvo"
				v-if="exibir"
				:carregaInformacoes="false"
				ref="cadUsuario"
				name="menu"
			/>
		</modal>
	</div>
</template>

<script>
import flCadastroDeUsuario from '../usuario/usuario/cadastro/main.vue'
var jwt_token = require('jwt-decode')
export default {
	components: {
		flCadastroDeUsuario
	},

	data() {
		return {
			exibir: false
		}
	},

	methods: {
		modalShow(token) {
			let dados = jwt_token(token)

			this.exibir = false
			this.$nextTick(() => {
				this.exibir = true
				this.$refs.modalNovoUsuario.modalShow(90)

				this.$nextTick(() => {
					this.$refs.cadUsuario.carregaUsuarioLogado({id: dados.id_usuario, menu: true, token: token})
				})
			})
		},

		usuarioSalvo() {
			this.$refs.modalNovoUsuario.modalHide()
			setTimeout(() => {
				this.$emit('salvou-novo-usuario')
			}, 2000)
		}
	}
}
</script>